<template>
  <!-- <pre v-if="responseData">testData={{ JSON.stringify(responseData, null, 2) }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/ASET.png"
        alt="ASET"
        class="pbt-image"
      >
      <div class="line-under-image" />
    </div>

    <div
      v-for="(item, index) in responseData"
      :key="index"
      class="content-wrapper"
    >
      <AppAutocomplete
        v-model="selectedYear"
        label="Tahun"
        :items="years"
        placeholder="Pilih Tahun"
        chips
        class="app-date-picker"
      />
  
      <h2>Laporan Kedudukan Aset JKT</h2>
      <!-- Keseluruhan Aset Section -->
      <h2>Keseluruhan Aset</h2>
      <div class="vektor">
        <!-- Kuantiti Box -->
        <div class="vektor-container">
          <img
            src="@/assets/spah/box.png"
            alt="First Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>Kuantiti</h3>
              <p class="number">
                {{ item.total_quantity }}
              </p>
            </div>
          </div>
        </div>

        <!-- Nilai Semasa Box -->
        <div class="vektor-container">
          <img
            src="@/assets/spah/box.png"
            alt="Second Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>Nilai Semasa (RM)</h3>
              <p class="number">
                {{ item.total_value }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Harta Modal Section -->
      <h2 class="section-title">
        <span class="section-number">1</span> Harta Modal
      </h2>
      <div class="vektor">
        <!-- Kuantiti Box -->
        <div class="vektor-container">
          <img
            src="@/assets/spah/box.png"
            alt="First Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>Kuantiti</h3>
              <p class="number">
                {{ item.modal_quantity }}
              </p>
            </div>
          </div>
        </div>

        <!-- Nilai Semasa Box -->
        <div class="vektor-container">
          <img
            src="@/assets/spah/box.png"
            alt="Second Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>Nilai Semasa (RM)</h3>
              <p class="number">
                {{ item.modal_value }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Aset Alih Bernilai Rendah Section -->
      <h2 class="section-title">
        <span class="section-number">2</span> Aset Alih Bernilai Rendah
      </h2>
      <div class="vektor">
        <!-- Kuantiti Box -->
        <div class="vektor-container">
          <img
            src="@/assets/spah/box.png"
            alt="First Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>Kuantiti</h3>
              <p class="number">
                {{ item.low_quantity }}
              </p>
            </div>
          </div>
        </div>

        <!-- Nilai Semasa Box -->
        <div class="vektor-container">
          <img
            src="@/assets/spah/box.png"
            alt="Second Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>Nilai Semasa (RM)</h3>
              <p class="number">
                {{ item.low_value }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PrimaryModule />
    <KhidmatPengurusan />
  </AdminBackground>
</template>

<script setup>
import KhidmatPengurusan from '@/components/menu-items/section-menu/khidmat-pengurusan-menu.vue'
import { useHttpService } from "@/httpService"
import { onMounted, ref } from 'vue'


definePage({
  alias: '/pages/pages/inspektorat/i-tegur',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const years = ref([2022, 2023, 2024])
const selectedYear = ref(2024)

const { httpGet, numberWithCommas } = useHttpService()

const responseData = ref(null)

async function loadDataFromApi(year) {
  try {
    const response = await fetch(`https://ejkt.kpkt.gov.my/eprofil/api/gate/management_assets?year=${year}`)
    const apiResponse = await response.json()

    responseData.value = apiResponse.data?.data || [] // Safely handle if `data.data` is undefined
  } catch (err) {
    console.error('loadDataFromApi failed:', err)
  }
}

// Watch for changes in selectedYear
watch(selectedYear, newYear => {
  loadDataFromApi(newYear) // Fetch data for the selected year
})

// Initial data load
onMounted(() => {
  loadDataFromApi(selectedYear.value)
})
</script>

<style scoped>
.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; /* Adjusted size */
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; 
  margin-block-start: 10px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); 
  border-radius: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  margin: 20px 0;
}




h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: left;
  text-transform: uppercase;
}

h3.section-title {
  color: rgb(21, 0, 105);
  font-size: 1.3rem;
  font-weight: bold;
  margin-block: 20px 10px;
  display: flex;
  align-items: center;
}

.section-number {
  background-color: #a4c4f9;
  color: white;
  padding: 5px 10px;
  border-radius: 50%;
  margin-inline-end: 10px;
  font-size: 1rem;
}

.vektor {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 10px; /* Adjust gap to add space between the boxes */
}

.vektor-container {
  width: 40%; /* Makes the box smaller */
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;
}

.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: Arial, sans-serif;
  text-align: center; /* Centers the text horizontally */
}

.values-layered h3 {
  margin: 0;
  font-size: 20px; /* Reduced size */
  font-weight: 600;
  color: #150069;
  text-align: center;
}

.number {
  font-size: 24px; /* Reduced size */
  font-weight: bold;
  color: #a80000;
  text-align: center;
}

@media (max-width: 1024px) {
  .vektor-container {
    width: 45%; /* Increase width slightly on medium screens */
  }
  
  .content-wrapper {
    padding: 15px;
  }

  h2 {
    font-size: 1.4rem;
  }
}

@media (max-width: 768px) {
  .vektor {
    flex-direction: column;
    align-items: center;
  }

  .vektor-container {
    width: 60%; /* Increase width for better readability */
  }

  .content-wrapper {
    padding: 15px;
  }

  h2 {
    font-size: 1.3rem;
  }

  h3.section-title {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
  }

  .vektor-container {
    width: 100%; /* Full width on mobile */
  }

  .image-wrapper {
    margin-block-end: 10px;
  }

  .pbt-image {
    max-inline-size: 90%;
  }

  .line-under-image {
    inline-size: 90%;
  }

  h2 {
    font-size: 1.2rem;
    margin-block: 20px 5px;
  }

  h3.section-title {
    font-size: 1rem;
    margin-block: 10px 5px;
  }

  .number {
    font-size: 20px;
  }
}
</style>
